import { Oui } from "./Oui";

export class TypeOuiNonGrpAcheteur {

	public oui: Oui;

	public non: string;

	constructor() {
		this.oui = new Oui();
		this.non = "false";

	}
}
